module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelManagerPage', {
    attrs: {
      "lower-app-name": "systemsettings",
      "lower-model-name": "systemsettings",
      "version": "1",
      "obj-label": "系统配置"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0118f6b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SystemSettingsManager.vue
// module id = 362
// module chunks = 1